import client from "./client";
import {
  UnionJobClassification,
  UnionClassificationRate,
  PostUnionClassificationRateRequest,
} from "../interfaces/UnionClassification";

function getErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const r = (err as { response?: { data?: { message?: string } } }).response;
    if (r?.data?.message) return r.data.message;
  }
  if (err instanceof Error) return err.message;
  return "Request failed";
}

export async function getUnionClassifications(
  activeOnly?: boolean
): Promise<UnionJobClassification[]> {
  const response = await client.get<UnionJobClassification[]>(
    "admin/union/classifications",
    { params: activeOnly === undefined ? {} : { activeOnly } }
  );
  return response.data;
}

export async function activateUnionClassification(
  projectClassification: number
): Promise<UnionJobClassification> {
  const response = await client.post<UnionJobClassification>(
    `admin/union/classifications/${projectClassification}/activate`
  );
  return response.data;
}

export async function deactivateUnionClassification(
  projectClassification: number
): Promise<UnionJobClassification> {
  const response = await client.post<UnionJobClassification>(
    `admin/union/classifications/${projectClassification}/deactivate`
  );
  return response.data;
}

export async function getUnionClassificationRates(
  projectClassification: number
): Promise<UnionClassificationRate[]> {
  const response = await client.get<UnionClassificationRate[]>(
    `admin/union/classifications/${projectClassification}/rates`
  );
  return response.data;
}

export async function postUnionClassificationRate(
  projectClassification: number,
  body: PostUnionClassificationRateRequest
): Promise<UnionClassificationRate> {
  const response = await client.post<UnionClassificationRate>(
    `admin/union/classifications/${projectClassification}/rates`,
    body
  );
  return response.data;
}

export { getErrorMessage };
